import regex from 'common/utils/regex';

export type FormAutoSaverType = {
  keyName: string;
  data: any;
};

export class FormAutoSaver {
  static readonly key = 'uniskai-form-data';

  static get(keyName?: string) {
    const allData = JSON.parse(
      localStorage.getItem(FormAutoSaver.key) || '[]',
      (_, value) => {
        if (typeof value === 'string' && regex.date.test(value)) {
          return new Date(value);
        }

        return value;
      },
    ) as FormAutoSaverType[];

    if (!keyName) return allData;

    const value = allData.find((item) => item.keyName === keyName);

    if (!value) return null;
    return value;
  }

  static set(keyName: string, data: any) {
    const allData = FormAutoSaver.get() as FormAutoSaverType[];

    const newData = JSON.stringify([
      ...allData.filter((item) => item.keyName !== keyName),
      {
        keyName,
        data,
      },
    ]);

    localStorage.setItem(FormAutoSaver.key, newData);
  }

  static remove(keyName?: string) {
    const allData = FormAutoSaver.get() as any;

    if (!keyName) {
      localStorage.removeItem(FormAutoSaver.key);
      return;
    }

    localStorage.setItem(
      FormAutoSaver.key,
      JSON.stringify(allData.filter((item) => item.keyName !== keyName)),
    );
  }
}
